<template>
  <div>{{ greetings }},</div>
</template>

<script>
export default {
  name: 'GreetingsComponent',

  data() {
    return {
      greetings: this.showGreeting(),
    }
  },

  methods: {
    // show greetings
    showGreeting() {
      const now = new Date()
      const hour = now.getHours()
      if (hour < 12) {
        return 'Good Morning'
      }
      else if (hour < 18) {
        return 'Good Afternoon'
      }
      else {
        return 'Good Evening'
      }
    },
  },
}
</script>
